import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { api } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Brands } from "../components/Brands";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { IntegrationFlow } from "../components/IntegrationFlow";
import { TechGLG } from "../components/TechGLG";
import { WhyChoose } from "../components/WhyChoose";
import { Process } from "../components/Process";
import { Testimonials } from "../components/Testimonials";
import { CTAFinal } from "../components/CTAFinal";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { WhatsAppButton } from "../components/WhatsAppButton";

export default function Home() {
  const { data } = useQuery({
    queryKey: ["public-site"],
    queryFn: async () => (await api.get("/public/site")).data,
  });

  const settings = data?.settings || {};
  const contact = settings.contact || {};
  const socials = settings.socials || {};
  const phone = contact.whatsapp || "50496390722";

  useEffect(() => {
    const seo = settings.seo || {};
    if (seo.title) document.title = seo.title;
    if (seo.description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", seo.description);
    }
  }, [settings.seo]);


  return (
    <div className="min-h-screen bg-glg-black">
      <Toaster position="bottom-center" theme="dark" richColors />
      <Navbar />
      <main>
        <Hero hero={settings.hero || {}} phone={phone} />
        <About about={settings.about || {}} />
        <Services services={data?.services || []} phone={phone} />
        <IntegrationFlow />
        <TechGLG software={data?.software || []} />
        <WhyChoose />
        <Process />
        <Testimonials testimonials={data?.testimonials || []} />
        <Brands brands={data?.brands || []} />
        <CTAFinal phone={phone} />
        <Contact contact={contact} socials={socials} />
      </main>
      <Footer contact={contact} socials={socials} />
      <WhatsAppButton phone={phone} />
    </div>
  );
}
